// ** Third Party
import Proptypes from "prop-types";
import { Controller } from "react-hook-form";
// ** Reactstrap
import { Input, Label } from "reactstrap";
import { useTranslation } from "react-i18next";
import CustomTooltip from "@components/ui-components/tooltip";
import classnames from "classnames";

const CheckboxField = (props) => {
    const { t } = useTranslation();
    const {
        label,
        name,
        disabled = false,
        control,
        className = "",
        id = "",
        tooltipContent = "",
        customOnChange = () => {},
        customCheckbox = false,
        labelClass = ""
    } = props;
    return (
        <Controller
            id={name}
            name={name}
            control={control}
            render={({ field: { value, onChange } }) => {
                return (
                    <div
                        className={classnames("position-relative", {
                            "mb-75"    : !className,
                            [className]: className
                        })}>
                        <Input
                            type="checkbox"
                            className={classnames({ customCheckbox: !customCheckbox })}
                            id={`checkbox-${id || name}`}
                            onChange={(e) => {
                                if (customOnChange) {
                                    customOnChange(e.target.checked);
                                }
                                onChange(e);
                            }}
                            checked={value}
                            disabled={disabled}/>
                        {label && (
                            <Label
                                htmlFor={`checkbox-${id || name}`}
                                data-cy={`label-${id}`}
                                className={
                                    !customCheckbox ? classnames("checkbox-label", {
                                        active      : value,
                                        border      : !value,
                                        disabled,
                                        [labelClass]: labelClass
                                    }) : "ms-75"
                                }>
                                {t(label)}
                                {Boolean(tooltipContent) && (
                                    <>
                                        <i
                                            className="mdi mdi-information-outline ms-75"
                                            id={`tooltip-${id}`}/>
                                        <CustomTooltip
                                            target={`tooltip-${id}`}
                                            content={tooltipContent}/>
                                    </>
                                )}
                            </Label>
                        )}
                    </div>
                );
            }}/>
    );
};

export default CheckboxField;

CheckboxField.propTypes = {
    label (props, propName) {
    // ** If label is defined and htmlFor is undefined throw error
        if (props[propName] && props["htmlFor"] === "undefined") {
            throw new Error("htmlFor prop is required when label prop is present");
        }
    },
    id            : Proptypes.string,
    name          : Proptypes.string.isRequired,
    serverErrors  : Proptypes.shape({}),
    disabled      : Proptypes.bool,
    control       : Proptypes.any.isRequired,
    className     : Proptypes.string,
    tooltipContent: Proptypes.any,
    customOnChange: Proptypes.func,
    customCheckbox: Proptypes.bool,
    labelClass    : Proptypes.string
};
